namespace RedBullMOBILE360.SalesApp {
    export class AddonColumns {
        static columnsKey = 'SalesApp.Addon';
    }
}